module.exports = __webpack_public_path__ + "img/left_layout_icon.10928b12.svg";